module.exports = __webpack_public_path__ + "img/video.f59d1beb.svg";